import { render } from "./UsageTable.vue?vue&type=template&id=24a4c1d8"
import script from "./UsageTable.vue?vue&type=script&lang=js"
export * from "./UsageTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__